import React, { useContext } from 'react';
import { AppBar, Box, Button, IconButton, Stack, TextField, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useResponsive } from '../helper/use-reponsive';
import { AuthContext } from '../helper/context/auth/authContext';
import AccountPopover from '../pages/header/userProfileIcon';
import PersonIcon from '@mui/icons-material/Person';
import { useMinimized } from '../helper/context/sideMenuContext/menuContext';

const Header = ({ onDrawerOpen }) => {
  const upLg = useResponsive('up', 'lg');
  const userData = JSON.parse(localStorage.getItem('userData'));

  const { logout } = useContext(AuthContext);
  const { isDrawerOpen, setDrawerOpen, setOpenSubMenu, setAnchorEl } = useMinimized();

  const menuIconClick = () => {
    setDrawerOpen(!isDrawerOpen); setOpenSubMenu(null); setAnchorEl(null)
  }
  const renderContent = (
    <>
      {!upLg &&
        <IconButton
          edge="start"
          onClick={() => menuIconClick()}
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
            display: 'block',
            color: "#000"
          }}
        >
          <MenuIcon sx={{ fontSize: '30px' }} />
        </IconButton>
      }
      <Box sx={{ flexGrow: 1 }} />
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            px: 2,
            py: 1,
            borderRadius: 1,
          }}
        >
<Box>
  <Typography 
    sx={{ 
      fontWeight: 700, 
      fontSize: '0.9rem', 
      color: '#000', 
      lineHeight: 0.5, // Reduces height between lines
      marginTop: '2px' // Tightens spacing below
    }}
  >
    {userData?.[0]?.UserName?.toUpperCase() || ''}
  </Typography>
  <Typography
    variant="caption"
    sx={{
      fontSize: '0.6rem',
      color: '#4a4a4a',
      lineHeight: 1, // Matches the above line height
    }}
  >
    {userData?.[0]?.RoleName || ''} - {userData?.[0]?.LocationName?.toUpperCase() || ''}
  </Typography>
</Box>

  <AccountPopover />
</Stack>
    </>
  );  

  return (
    <AppBar position="sticky" sx={{
      background: "linear-gradient(180deg,rgb(255, 255, 255),rgb(249, 250, 252))",
      zIndex:9,

      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      fontFamily: "'Poppins', sans-serif",
    }}>
      <Toolbar sx={{
        display: 'flex',
        justifyContent: upLg ? 'space-between' : 'space-between',
        padding: upLg ? '0 20px' : '0 10px',
        alignItems: 'center'
      }}>
        {renderContent}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
